/* The showCount counter hangs one text line below the TextArea (absolute,
   out of flow), so the help text needs that much extra room or they overlap */
.helpBelowCounter :global(.ant-form-item-explain) {
  margin-top: calc(var(--ant-font-size) * var(--ant-line-height));
}
